class CouponCodes extends HTMLElement {
  connectedCallback() {
    this.copyButtons = this.querySelectorAll('[data-copy-code]');
    this.copyButtons.forEach((button) => {
      button.addEventListener('click', this.onCopyClick.bind(this, button));
    });
  }

  async onCopyClick(button) {
    const code = button.dataset.copyCode;
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
    } catch (error) {
      const textArea = document.createElement('textarea');
      textArea.value = code;
      textArea.setAttribute('readonly', '');
      textArea.style.position = 'absolute';
      textArea.style.left = '-9999px';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }

    const defaultLabel = button.dataset.defaultLabel || code;
    const buttonText = button.querySelector('.coupon-codes__button-text');
    button.classList.add('is-copied');

    if (buttonText) {
      buttonText.textContent = button.dataset.copiedLabel || 'Copied!';
    } else {
      button.textContent = button.dataset.copiedLabel || 'Copied!';
    }

    window.clearTimeout(button.copyTimeout);
    button.copyTimeout = window.setTimeout(() => {
      button.classList.remove('is-copied');
      if (buttonText) {
        buttonText.textContent = defaultLabel;
      } else {
        button.textContent = defaultLabel;
      }
    }, 2000);
  }
}

customElements.define('coupon-codes', CouponCodes);
